import { typography } from "@mui/system";

const styles = (theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		// O Modal foca automaticamente o primeiro elemento focável ao abrir; quando o gatilho é um
		// evento de teclado (ex: tecla Delete/Backspace), o navegador aplica :focus-visible e desenha
		// o anel de foco nativo ao redor desse elemento — visível mesmo sem nenhum tab manual
		"& *:focus-visible": {
			outline: "none",
		},
	},
	paper: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		borderRadius: "20px",
		bgcolor: theme.palette.secondary.darker,
		justifyContent: "center",
		width: "400px",
		minHeight: "350px",
		maxWidth: "80vw",
		maxHeight: "90vh",
		padding: {
			xs: "20px",
			sm: "20px",
		},
	},
	paperInterno: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		borderRadius: "20px",
		width: "360px",
		bgcolor: theme.palette.background.modalContrast,
		minHeight: "270px",
		mt: "50px",
		maxWidth: "70vw",
		paddingY: {
			xs: "10px",
			sm: "20px",
		},
		paddingBottom: "20px",
	},

	header: {
		display: "flex",
		justifyContent: "center",
		mt: 2,
	},
	circleWhiteMode: {
		position: "absolute",
		top: "20px",
		width: "88px",
		height: "88px",
		bgcolor: `${theme.palette.secondary.darker}`,
		borderRadius: "50%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	circleTransparent: {
		position: "absolute",
		top: "20px",
		width: "88px",
		height: "88px",
		borderRadius: "50%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	circleFixed: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		width: "66px",
		height: "66px",
		borderRadius: "50%",
	},
	typographyIcon: {
		fontSize: "50px",
		fontWeight: 700,
		color: theme.palette.white.main,
	},
	errorIcon: {
		fontSize: "40px",
		mb: 1,
		color: theme.palette.white.main,
	},
	title: {
		mt: "8px",
		fontSize: "24px",
		fontWeight: 700,
		textAlign: "center",
	},
	boxTextContent: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		mt: 2,
		gap: 1,
		paddingX: 2,
	},
	typographyText: {
		fontSize: "16px",
		textAlign: "center",
		"@media (max-width: 465px)": {
			fontSize: "16px",
		},
	},

	contentText: { textAlign: "center" },
	boxButtons: {
		display: "flex",
		justifyContent: "space-around",
		width: "100%",
		mt: 3,
		"@media (max-width: 412px)": {
			mt: 2,
		},
	},
});

export default styles;
